"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PurchaseTermsModal = require("./PurchaseTermsModal");
Object.keys(_PurchaseTermsModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PurchaseTermsModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PurchaseTermsModal[key];
    }
  });
});
var _PurchaseTermsModalContext = require("./context/PurchaseTermsModalContext");
Object.keys(_PurchaseTermsModalContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PurchaseTermsModalContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PurchaseTermsModalContext[key];
    }
  });
});